"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _immutable = _interopRequireDefault(require("immutable"));

var _I18n = _interopRequireDefault(require("I18n"));

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _UIBackButton = _interopRequireDefault(require("UIComponents/nav/UIBackButton"));

var _UIImage = _interopRequireDefault(require("UIComponents/image/UIImage"));

var _UIFormControl = _interopRequireDefault(require("UIComponents/form/UIFormControl"));

var _UIMedia = _interopRequireDefault(require("UIComponents/layout/UIMedia"));

var _UIMediaRight = _interopRequireDefault(require("UIComponents/layout/UIMediaRight"));

var _UIMediaBody = _interopRequireDefault(require("UIComponents/layout/UIMediaBody"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var _preloadImage = _interopRequireDefault(require("FileManagerCore/utils/preloadImage"));

var _Constants = require("FileManagerCore/Constants");

var _FromUrlInput = _interopRequireDefault(require("FileManagerLib/components/browser/FromUrlInput"));

var _ErrorMessages;

var Errors = (0, _keyMirror.default)({
  NOT_FOUND: null,
  DATA_URI: null
});
var ErrorMessages = (_ErrorMessages = {}, (0, _defineProperty2.default)(_ErrorMessages, Errors.NOT_FOUND, 'loadingError'), (0, _defineProperty2.default)(_ErrorMessages, Errors.DATA_URI, 'dataUri'), _ErrorMessages);

function i18nKey(suffix) {
  return "FileManagerLib.panels.fromUrl." + suffix;
}

function getErrorMessage(error) {
  return _I18n.default.text(i18nKey("errors." + ErrorMessages[error]));
}

var FromUrlPanel =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(FromUrlPanel, _Component);

  function FromUrlPanel(props) {
    var _this;

    (0, _classCallCheck2.default)(this, FromUrlPanel);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(FromUrlPanel).call(this, props));
    _this.state = {
      tempImageUrl: '',
      image: null,
      error: null
    };
    _this.handleUrlChange = _this.handleUrlChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleKeyUp = _this.handleKeyUp.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleInsert = _this.handleInsert.bind((0, _assertThisInitialized2.default)(_this));
    _this.handlePreview = _this.handlePreview.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(FromUrlPanel, [{
    key: "getDimensions",
    value: function getDimensions(image) {
      return image.get('width') + " x " + image.get('height') + " px";
    }
  }, {
    key: "handleUrlChange",
    value: function handleUrlChange(event) {
      this.setState({
        tempImageUrl: event.target.value
      });
    }
  }, {
    key: "handlePreview",
    value: function handlePreview() {
      var _this2 = this;

      var tempImageUrl = this.state.tempImageUrl;

      if (tempImageUrl.startsWith('data:')) {
        this.setState({
          error: Errors.DATA_URI,
          image: null
        });
        return;
      }

      if (!tempImageUrl) {
        return;
      }

      (0, _preloadImage.default)(tempImageUrl, function (meta) {
        _this2.setState({
          image: _immutable.default.Map((0, _extends2.default)({
            id: -1,
            url: tempImageUrl,
            type: _Constants.FileTypes.IMG
          }, meta)),
          error: null
        });
      }, function () {
        _this2.setState({
          error: Errors.NOT_FOUND,
          image: null
        });
      });
    }
  }, {
    key: "handleKeyUp",
    value: function handleKeyUp(event) {
      if (event.key === 'Enter') {
        this.handlePreview();
      }
    }
  }, {
    key: "handleInsert",
    value: function handleInsert() {
      var image = this.state.image;
      var onInsert = this.props.onInsert;
      onInsert(image);
    }
  }, {
    key: "renderPreview",
    value: function renderPreview() {
      var image = this.state.image;
      return _react.default.createElement("div", {
        className: "from-url-panel__preview m-top-4"
      }, _react.default.createElement("span", {
        className: "from-url-panel__preview-heading"
      }, _I18n.default.text(i18nKey('imagePreview'))), _react.default.createElement(_UIImage.default, {
        className: "from-url-panel__preview-image",
        src: image.get('url')
      }), _react.default.createElement(_UIMedia.default, {
        className: "m-top-6"
      }, _react.default.createElement(_UIMediaBody.default, null, _react.default.createElement(_Small.default, {
        use: "help",
        tagName: "p"
      }, image.get('name') + "." + image.get('extension'), _react.default.createElement("br", null), _I18n.default.text('FileManagerLib.fileDetail.dimensions', {
        dimensions: this.getDimensions(image)
      }))), _react.default.createElement(_UIMediaRight.default, null, _react.default.createElement(_UIButton.default, {
        use: "primary",
        onClick: this.handleInsert
      }, _I18n.default.text('FileManagerLib.actions.insert')))));
    }
  }, {
    key: "render",
    value: function render() {
      var onBack = this.props.onBack;
      var _this$state = this.state,
          tempImageUrl = _this$state.tempImageUrl,
          image = _this$state.image,
          error = _this$state.error;
      return _react.default.createElement(_UIFlex.default, {
        direction: "column"
      }, _react.default.createElement(_UIBackButton.default, {
        className: "m-y-4"
      }, _react.default.createElement(_UILink.default, {
        onClick: onBack
      }, _react.default.createElement(_Small.default, null, _I18n.default.text('FileManagerLib.backButton')))), _react.default.createElement(_UIFormControl.default, {
        className: "from-url-panel__url-field",
        label: _I18n.default.text(i18nKey('imageUrl')),
        error: !!error,
        validationMessage: error ? getErrorMessage(error) : null
      }, _react.default.createElement(_FromUrlInput.default, {
        value: tempImageUrl,
        onKeyUp: this.handleKeyUp,
        onChange: this.handleUrlChange,
        onPreview: this.handlePreview
      })), image && !error && this.renderPreview());
    }
  }]);
  return FromUrlPanel;
}(_react.Component);

FromUrlPanel.propTypes = {
  onInsert: _react.PropTypes.func.isRequired,
  onBack: _react.PropTypes.func.isRequired
};
var _default = FromUrlPanel;
exports.default = _default;
module.exports = exports.default;